import TopNavigation from '@amzn/awsui-components-console/top-navigation';
import { TopNavigationProps } from '@amzn/awsui-components-console/top-navigation';
import { AppicationsItemIds, UserItemIds } from '@pages/constants';
import { useExternalModuleNavigate } from '@pages/hooks/externalNavigate';
import * as React from 'react';
import { useNavigate } from 'react-router';
import whiteLogo from 'src/assets/logo_white.png';
import { CONSTANTS } from 'src/resources/constants';
import { AppPaths } from 'src/routes/Routes';
import { useAppDispatch, useAppSelector } from 'src/stores/slices/hooks';
import {
  selectUsername,
  toggleSelectSite,
  toggleUserPreferences,
} from 'src/stores/slices/userSlice';

const IscTopNav = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const username = useAppSelector(selectUsername);
  const navigate = useNavigate();
  const { navigateToSecuMod } = useExternalModuleNavigate();

  const i18nStrings = {
    searchIconAriaLabel: 'Search',
    searchDismissIconAriaLabel: 'Close search',
    overflowMenuTriggerText: 'More',
  };

  const title = 'ISC Device Rename';

  const utilities: TopNavigationProps.Utility[] = [
    {
      type: 'button',
      text: 'Select Site(s)',
      iconName: 'edit',
      ariaLabel: 'Select Sites',
      badge: false,
      disableUtilityCollapse: true,
      onClick: (): void => {
        dispatch(toggleSelectSite());
      },
    },
    {
      type: 'menu-dropdown',
      text: 'Applications',
      items: [
        {
          id: AppicationsItemIds.Milestone,
          text: 'Milestone',
          ariaLabel: 'Milestone',
        },
        {
          id: AppicationsItemIds.SecuMod,
          text: 'SecuMod',
          ariaLabel: 'SecuMod',
        },
      ],
      onItemClick: event => {
        switch (event.detail.id) {
          case AppicationsItemIds.Milestone:
            navigate(AppPaths.Milestone);
            break;
          case AppicationsItemIds.SecuMod:
            navigateToSecuMod();
            break;
        }
      },
    },
    {
      type: 'menu-dropdown',
      text: username,
      iconName: 'user-profile',
      items: [
        {
          id: UserItemIds.Preferences,
          text: 'Preferences',
          iconName: 'settings',
          ariaLabel: 'User Preferences',
        },
        {
          text: 'Help',
          items: [
            {
              id: UserItemIds.ReportBug,
              text: 'Report a Bug',
              href: CONSTANTS.REPORT_BUG,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
            {
              id: UserItemIds.FeatureRequest,
              text: 'Feature Requests',
              href: CONSTANTS.FEATURE_REQUEST,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
            {
              id: UserItemIds.UserGuide,
              text: 'End User Guide',
              href: CONSTANTS.WIKI_LINK,
              external: true,
              externalIconAriaLabel: ' (opens in new tab)',
            },
          ],
        },
      ],
      onItemClick: event => {
        switch (event.detail.id) {
          case UserItemIds.Preferences:
            dispatch(toggleUserPreferences());
            break;
        }
      },
    },
  ];

  return (
    <div
      className="awsui"
      id="header"
      style={{ position: 'sticky', top: 0, zIndex: 1002 }}>
      <TopNavigation
        i18nStrings={i18nStrings}
        identity={{
          href: '#',
          title: title,
          logo: {
            src: whiteLogo,
            alt: 'Amazon Corporate Security',
          },
        }}
        utilities={utilities}
      />
    </div>
  );
};

export default IscTopNav;
